/**
 * Utilitaires pour la gestion des projets et calculs de phases
 */

/**
 * Génère un ID unique basé sur le timestamp et un nombre aléatoire
 */
export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

/**
 * Ajoute un nombre de semaines à une date
 */
export const addWeeks = (date, weeks) => {
  const result = new Date(date);
  result.setDate(result.getDate() + (weeks * 7));
  return result;
};

/**
 * Ajoute un nombre de jours à une date
 */
export const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

/**
 * Vérifie si deux périodes se chevauchent
 */
export const periodsOverlap = (start1, end1, start2, end2) => {
  return start1 <= end2 && start2 <= end1;
};

/**
 * Calcule le nombre de jours ouvrables entre deux dates
 */
export const getWorkingDaysBetween = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  let count = 0;
  const curDate = new Date(start);
  
  while (curDate <= end) {
    const dayOfWeek = curDate.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Pas weekend
      count++;
    }
    curDate.setDate(curDate.getDate() + 1);
  }
  
  return count;
};

/**
 * Calcule la capacité hebdomadaire d'une personne
 */
export const calculateWeeklyCapacity = (personne, pourcentageTemps = 100) => {
  const indiceProductivite = parseFloat(personne.indice_productivite || 0);
  const capaciteHebdo = 5 * indiceProductivite; // 5 jours par semaine
  return capaciteHebdo * (pourcentageTemps / 100);
};

/**
 * Formate une durée en semaines pour l'affichage
 */
export const formatDuration = (weeks) => {
  if (weeks === 0) return 'Non calculé';
  if (weeks < 1) return `${Math.round(weeks * 7)} jour${Math.round(weeks * 7) !== 1 ? 's' : ''}`;
  return `${weeks} semaine${weeks !== 1 ? 's' : ''}`;
};

/**
 * Valide qu'une affectation est complète
 */
export const validateAffectation = (affectation, personnesData) => {
  const errors = {};
  
  if (!affectation.id_personne) {
    errors.personne = 'Veuillez sélectionner une personne';
  }
  
  if (!affectation.pourcentage_temps || affectation.pourcentage_temps < 1 || affectation.pourcentage_temps > 100) {
    errors.pourcentage = 'Le pourcentage doit être entre 1 et 100';
  }
  
  if (!affectation.role_projet) {
    errors.role = 'Veuillez sélectionner un rôle';
  }
  
  return errors;
};

/**
 * Calcule les conflits d'affectation pour une personne
 */
export const calculateAffectationConflicts = (personneId, dateDebut, dateFin, existingAffectations = []) => {
  return existingAffectations.filter(affectation => 
    affectation.id_personne === personneId &&
    periodsOverlap(
      new Date(dateDebut), 
      new Date(dateFin), 
      new Date(affectation.date_debut), 
      new Date(affectation.date_fin)
    )
  );
};
